/* eslint-disable react/no-unescaped-entities */
import React, { useState, useEffect } from 'react';
import {
    Star,
    ChevronRight,
    Zap,
    Shield,
    CircleCheck,
    X,
    Bell,
    BarChart,
    RefreshCw,
    Brain,
    Check,

    ChevronDown,
    Menu
} from 'lucide-react';

import logo2 from '../assets/logo2.png';
import celular from '../assets/celular.png';
import ricardo from '../assets/ricardo.png';
import ana from '../assets/ana.png';
import lucas from '../assets/lucas.png';

const LandingPage = ({ onGetStarted }) => {
    useEffect(() => {
        document.documentElement.classList.remove('dark');
        return () => {
            const savedTheme = localStorage.getItem('theme');
            if (savedTheme === 'dark') {
                document.documentElement.classList.add('dark');
            }
        };
    }, []);

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [openFaqIndex, setOpenFaqIndex] = useState(null);

    const toggleFaq = (index) => {
        setOpenFaqIndex(openFaqIndex === index ? null : index);
    };

    const handleSubscribe = async (priceId) => {
        try {
            const apiBaseUrl = process.env.REACT_APP_API_URL || '';
            const response = await fetch(`${apiBaseUrl}/api/create-public-checkout-session`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    price_id: priceId,
                    cancel_url: window.location.href
                })
            });

            const { url } = await response.json();
            if (url) window.location.href = url;
            else alert('Erro ao iniciar checkout. Tente novamente.');
        } catch (err) {
            console.error("Payment error", err);
            alert("Erro ao conectar com o servidor.");
        }
    };

    const faqs = [
        {
            question: "E se eu falhar um dia?",
            answer: "O SkipLater foi feito para isso. Não existe 'perder tudo'. Você apenas retoma no dia seguinte e continua somando XP. O importante é a constância a longo prazo, não a perfeição."
        },
        {
            question: "Preciso ter muito tempo?",
            answer: "Não! A metodologia foca em micro-hábitos que levam de 2 a 10 minutos. A ideia é caber na sua rotina atual, não criar uma nova."
        },
        {
            question: "Em quanto tempo vira hábito?",
            answer: "Estudos variam, mas a média é de 66 dias. Porém, com o sistema gamificado do SkipLater, você começa a sentir os benefícios logo na primeira semana."
        },
        {
            question: "Como recebo acesso após pagar?",
            answer: "O acesso é liberado imediatamente após a confirmação do pagamento. Você receberá um e-mail com os detalhes para entrar na plataforma."
        },
        {
            question: "Posso cancelar?",
            answer: "Sim, a qualquer momento. Se não estiver satisfeito, basta cancelar nas configurações da conta e não haverá cobranças futuras."
        }
    ];
    return (
        <div className="min-h-screen bg-background text-foreground font-sans antialiased">
            <header className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-md border-b border-border/50 supports-[backdrop-filter]:bg-background/60">
                <div className="container mx-auto px-4 h-16 flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <img src={logo2} alt="SkipLater" className="h-10 w-auto rounded-lg" />
                    </div>

                    <nav className="hidden md:flex items-center gap-8">
                        <a href="#como-funciona" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">Como funciona</a>
                        <a href="#features" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">Funcionalidades</a>
                        <a href="#precos" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">Planos</a>
                    </nav>

                    <div className="flex items-center gap-4 md:gap-6">
                        <button
                            onClick={onGetStarted}
                            className="hidden md:block text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
                        >
                            Entrar
                        </button>
                        <a
                            href="#precos"
                            className="hidden md:inline-flex items-center justify-center rounded-full text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground shadow-sm hover:bg-primary/90 h-9 px-5"
                        >
                            Começar
                        </a>
                        <button
                            className="md:hidden"
                            onClick={() => setIsMenuOpen(!isMenuOpen)}
                        >
                            {isMenuOpen ? <X /> : <Menu />}
                        </button>
                    </div>
                </div>
                {isMenuOpen && (
                    <div className="md:hidden border-t border-border/50 bg-background/95 backdrop-blur-md p-4 animate-in slide-in-from-top-2">
                        <nav className="flex flex-col gap-4">
                            <a
                                href="#como-funciona"
                                className="text-sm font-medium hover:text-primary transition-colors"
                                onClick={() => setIsMenuOpen(false)}
                            >
                                Como funciona
                            </a>
                            <a
                                href="#features"
                                className="text-sm font-medium hover:text-primary transition-colors"
                                onClick={() => setIsMenuOpen(false)}
                            >
                                Funcionalidades
                            </a>
                            <a
                                href="#precos"
                                className="text-sm font-medium hover:text-primary transition-colors"
                                onClick={() => setIsMenuOpen(false)}
                            >
                                Planos
                            </a>
                            <hr className="border-border/50" />
                            <button
                                onClick={onGetStarted}
                                className="text-sm font-medium text-left hover:text-primary transition-colors"
                            >
                                Entrar
                            </button>
                            <a
                                href="#precos"
                                onClick={() => setIsMenuOpen(false)}
                                className="inline-flex items-center justify-center rounded-full text-sm font-medium transition-colors bg-primary text-primary-foreground shadow-sm hover:bg-primary/90 h-10 w-full"
                            >
                                Começar Agora
                            </a>
                        </nav>
                    </div>
                )}
            </header>
            <main>
                <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-0 overflow-hidden bg-background">
                    <div className="container px-4 mx-auto relative z-10">
                        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center min-h-[600px] lg:min-h-[700px]">
                            <div>
                                <div className="inline-flex items-center rounded-full border px-4 py-1.5 text-xs font-semibold bg-orange-50 text-orange-600 border-orange-200 mb-8 animate-in fade-in slide-in-from-bottom-4 duration-700 shadow-sm">
                                    <Star className="w-3 h-3 mr-1.5 fill-orange-600" />
                                    Pule o “depois”. Construa hábitos melhores.
                                </div>
                                <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight mb-6 leading-[1.1] animate-in fade-in slide-in-from-bottom-8 duration-700 delay-100 text-foreground">
                                    O <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-red-600">“depois”</span> está roubando seus dias.
                                </h1>
                                <p className="text-lg text-muted-foreground mb-10 animate-in fade-in slide-in-from-bottom-8 duration-700 delay-200 leading-relaxed max-w-xl">
                                    Você não precisa de mais motivação. Você precisa de um sistema simples pra começar hoje — nem que seja pequeno — e manter o ritmo.
                                </p>
                                <div className="flex flex-col sm:flex-row gap-4 items-start animate-in fade-in slide-in-from-bottom-8 duration-700 delay-300">
                                    <button
                                        onClick={onGetStarted}
                                        className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 h-14 px-8 text-lg bg-primary hover:bg-primary/90 text-primary-foreground shadow-xl shadow-primary/25 transition-all hover:scale-105 rounded-full"
                                    >
                                        Começar Agora
                                        <ChevronRight className="w-5 h-5 ml-2" />
                                    </button>
                                </div>
                                <div className="mt-6 flex flex-wrap gap-4 text-sm text-muted-foreground animate-in fade-in slide-in-from-bottom-8 duration-700 delay-300">
                                    <span className="flex items-center gap-1.5">
                                        <Zap className="w-4 h-4 text-primary" /> Acesso imediato
                                    </span>
                                    <span className="flex items-center gap-1.5">
                                        <Shield className="w-4 h-4 text-primary" /> Pagamento seguro
                                    </span>
                                    <span className="flex items-center gap-1.5">
                                        <CircleCheck className="w-4 h-4 text-primary" /> Cancele quando quiser
                                    </span>
                                </div>
                            </div>
                            <div className="relative h-full min-h-[500px] lg:min-h-[700px] flex items-center justify-center animate-in fade-in slide-in-from-right-12 duration-1000 delay-300">
                                <div className="relative z-10 w-full max-w-sm mx-auto">
                                    <div className="relative group">
                                        <div className="absolute -inset-6 bg-gradient-to-r from-orange-200/30 via-orange-100/20 to-orange-200/30 rounded-[3rem] blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                                        <div className="relative rounded-3xl border-8 border-white shadow-2xl overflow-hidden bg-white backdrop-blur-sm transform group-hover:scale-105 transition-transform duration-500">
                                            {/* Using a placeholder div instead of the specific image path which might be broken */}
                                            <div className="w-full bg-gradient-to-b from-gray-50 to-gray-100 flex flex-col items-center justify-center overflow-hidden">
                                                <img
                                                    src={celular}
                                                    alt="App SkipLater Preview"
                                                    className="w-full h-auto object-cover transform hover:scale-105 transition-transform duration-500"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="dor" className="py-24 bg-secondary/30">
                    <div className="container px-4 mx-auto">
                        <div className="text-center mb-16 max-w-3xl mx-auto">
                            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-foreground">
                                A dor é real: por que é tão difícil mudar?
                            </h2>
                        </div>

                        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto mb-16">
                            {[
                                "Você começa empolgado, mas para na primeira semana.",
                                "A mentalidade 'tudo ou nada' te faz desistir após um erro.",
                                "O celular rouba sua atenção e o tempo voa.",
                                "Você define metas irreais e se frustra rápido."
                            ].map((item, index) => (
                                <div key={index} className="flex gap-4 items-center p-8 bg-white rounded-3xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
                                    <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center shrink-0 text-red-500">
                                        <X className="w-6 h-6" />
                                    </div>
                                    <p className="text-lg font-medium text-gray-700">{item}</p>
                                </div>
                            ))}
                        </div>

                        <div className="text-center">
                            <h3 className="text-2xl font-bold mb-2">Você não precisa de mais motivação.</h3>
                            <p className="text-3xl font-extrabold text-orange-600">Você precisa de um sistema.</p>
                        </div>
                    </div>
                </section>

                <section id="como-funciona" className="py-24 bg-white relative overflow-hidden">
                    <div className="container px-4 mx-auto relative z-10">
                        <div className="text-center mb-20">
                            <h2 className="text-4xl font-bold mb-4 text-gray-900">Como o SkipLater funciona</h2>
                        </div>

                        <div className="relative max-w-5xl mx-auto">
                            {/* Connecting line for desktop */}
                            <div className="hidden md:block absolute top-[3rem] left-0 w-full h-1 bg-orange-100 -z-10"></div>

                            <div className="grid md:grid-cols-3 gap-12">
                                {[
                                    { step: "1", title: "Crie seu Hábito", desc: "Escolha entre modelos prontos ou crie o seu. Defina a frequência e comece pequeno." },
                                    { step: "2", title: "Faça o Check-in", desc: "Marque sua atividade diária em segundos. Sem burocracia, direto ao ponto." },
                                    { step: "3", title: "Acompanhe a Evolução", desc: "Veja seus dias consecutivos (streak) crescerem e ganhe XP a cada vitória." }
                                ].map((item, i) => (
                                    <div key={i} className="flex flex-col items-center text-center">
                                        <div className="w-24 h-24 rounded-2xl bg-white border-4 border-orange-50 shadow-xl flex items-center justify-center text-3xl font-bold text-orange-500 mb-8 z-10">
                                            {item.step}
                                        </div>
                                        <h3 className="text-2xl font-bold mb-4 text-gray-900">{item.title}</h3>
                                        <p className="text-muted-foreground leading-relaxed max-w-xs mx-auto">
                                            {item.desc}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>

                <section id="features" className="py-24 bg-background/50">
                    <div className="container px-4 mx-auto">
                        <div className="text-center mb-20">
                            <h2 className="text-4xl font-bold mb-6 text-foreground">Tudo o que você precisa para manter o foco</h2>
                            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">Ferramentas essenciais para você construir constância de forma leve.</p>
                        </div>
                        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-16 max-w-6xl mx-auto">
                            {[
                                { title: "Seus Hábitos", desc: "Crie listas personalizadas ou escolha sugestões como meditação, leitura e exercícios." },
                                { title: "Formato Gamificado", desc: "Ganhe XP e suba de nível. Transforme sua rotina em um jogo viciante (do bem)." },
                                { title: "Sistema de Pontos", desc: "Acumule cristais a cada tarefa concluída e visualize seu progresso tangível." },
                                { title: "Recompensas e Conquistas", desc: "Desbloqueie medalhas e troféus virtuais para manter a motivação lá no alto." },
                                { title: "Personalização", desc: "Adapte o app ao seu estilo de vida. Defina metas flexíveis e dias de descanso." },
                                { title: "Comunidade", desc: "Junte-se a grupos (em breve), compartilhe vitórias e inspire-se com outros usuários." }
                            ].map((item, i) => (
                                <div key={i} className="flex flex-col items-center text-center">
                                    <div className="mb-6 transform transition-transform hover:scale-110 duration-300">
                                        <Star className="w-12 h-12 text-orange-500 fill-orange-500" />
                                    </div>
                                    <h3 className="text-xl font-bold mb-3 text-foreground">{item.title}</h3>
                                    <p className="text-muted-foreground leading-relaxed">{item.desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section id="ciencia" className="py-24 bg-white">
                    <div className="container px-4 mx-auto max-w-4xl">
                        <div className="flex flex-col md:flex-row gap-12 items-center">
                            <div className="flex-1">
                                <div className="inline-flex items-center rounded-full border px-3 py-1 text-xs font-semibold bg-blue-50 text-blue-600 border-blue-200 mb-6">
                                    <Brain className="w-3 h-3 mr-2" /> Baseado em ciência
                                </div>
                                <h2 className="text-3xl font-bold mb-6">Por que “pequeno + repetível + no mesmo contexto” funciona melhor</h2>
                                <div className="prose prose-orange text-muted-foreground">
                                    <p className="mb-4">Um dos estudos mais citados sobre formação de hábito observou que a automaticidade cresce com a repetição no mesmo contexto (ex: "depois do café").</p>
                                    <p className="mb-6">Revisões na área apontam três peças-chave para consistência: <strong>(1) repetição</strong>, <strong>(2) pistas do contexto (gatilhos)</strong> e <strong>(3) recompensas</strong>.</p>
                                    <p className="font-medium text-foreground">O SkipLater segue exatamente essa lógica: você repete um hábito pequeno, ligado a um gatilho claro, com progresso visível, um dia por vez.</p>
                                </div>
                            </div>
                            <div className="flex-1 bg-secondary/30 p-8 rounded-3xl">
                                <h3 className="font-bold text-lg mb-4">Para quem é o SkipLater?</h3>
                                <ul className="space-y-3">
                                    {[
                                        "Quer criar hábitos com pouco tempo (2–10 min)",
                                        "Está cansado de recomeçar toda segunda",
                                        "Quer constância sem perfeccionismo",
                                        "Quer um sistema simples, não mais uma tarefa"
                                    ].map((text, i) => (
                                        <li key={i} className="flex gap-3 items-center">
                                            <Check className="w-5 h-5 text-green-500 shrink-0" />
                                            <span>{text}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="precos" className="py-24 bg-background">
                    <div className="container px-4 mx-auto max-w-5xl">
                        <div className="text-center mb-16">
                            <h2 className="text-3xl md:text-4xl font-bold mb-4">Escolha seu ritmo</h2>
                            <p className="text-lg text-muted-foreground">Comece agora e teste o sistema.</p>
                        </div>
                        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto items-center">
                            <div className="relative rounded-3xl border-2 p-8 flex flex-col transition-all duration-300 border-border bg-background/50">
                                <h3 className="text-xl font-bold mb-2">Plano Mensal</h3>
                                <div className="mb-6">
                                    <span className="text-4xl font-bold">R$ 9,90</span>
                                    <span className="text-muted-foreground text-sm font-medium">/mês</span>
                                </div>
                                <ul className="space-y-3 mb-8 flex-1">
                                    {["Acesso completo", "Atualizações", "Cancele quando quiser"].map((text, i) => (
                                        <li key={i} className="flex gap-3 text-sm">
                                            <Check className="w-5 h-5 text-primary shrink-0" />
                                            <span>{text}</span>
                                        </li>
                                    ))}
                                </ul>
                                <button onClick={() => handleSubscribe(process.env.REACT_APP_STRIPE_PRICE_MONTHLY)} className="inline-flex items-center justify-center gap-2 whitespace-nowrap transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 border border-input shadow-sm hover:bg-accent hover:text-accent-foreground h-9 px-4 w-full py-6 text-lg rounded-xl font-bold">
                                    Assinar Mensal
                                </button>
                            </div>
                            <div className="relative rounded-3xl border-2 p-8 flex flex-col transition-all duration-300 border-primary bg-white shadow-xl scale-105">
                                <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-primary text-primary-foreground text-xs font-bold px-4 py-1.5 rounded-full">RECOMENDADO</div>
                                <h3 className="text-xl font-bold mb-2">Plano Anual</h3>
                                <div className="mb-6">
                                    <span className="text-4xl font-bold">R$ 97</span>
                                    <span className="text-muted-foreground text-sm font-medium">/ano</span>
                                </div>
                                <ul className="space-y-3 mb-8 flex-1">
                                    {["Melhor custo-benefício", "Menos de R$ 0,27/dia", "Construa 2026 com constância"].map((text, i) => (
                                        <li key={i} className="flex gap-3 text-sm">
                                            <Check className="w-5 h-5 text-primary shrink-0" />
                                            <span>{text}</span>
                                        </li>
                                    ))}
                                </ul>
                                <button onClick={() => handleSubscribe(process.env.REACT_APP_STRIPE_PRICE_YEARLY)} className="inline-flex items-center justify-center gap-2 whitespace-nowrap transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground shadow hover:bg-primary/90 h-9 px-4 w-full py-6 text-lg rounded-xl font-bold">
                                    Assinar Anual
                                </button>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="py-24 bg-orange-50/50">
                    <div className="container px-4 mx-auto max-w-6xl">
                        <div className="grid lg:grid-cols-2 gap-12 items-center">
                            <div className="space-y-8">
                                <h2 className="text-4xl font-bold text-gray-900">O que as pessoas estão dizendo...</h2>

                                <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex items-start gap-4">
                                    <div className="w-12 h-12 rounded-full bg-gray-200 overflow-hidden shrink-0">
                                        <img src={ricardo} alt="Ricardo" className="w-full h-full object-cover" />
                                    </div>
                                    <div>
                                        <h4 className="font-bold text-gray-900">Ricardo M.</h4>
                                        <p className="text-xs text-orange-500 font-semibold uppercase tracking-wide mb-2">Desenvolvedor</p>
                                        <p className="text-gray-600 text-sm">"Esse app adicionou um valor real à minha rotina sedentária. Finalmente me sinto motivado a me mexer."</p>
                                    </div>
                                </div>

                                <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex items-start gap-4 transform lg:translate-x-8">
                                    <div className="w-12 h-12 rounded-full bg-gray-200 overflow-hidden shrink-0">
                                        <img src={ana} alt="Ana" className="w-full h-full object-cover" />
                                    </div>
                                    <div>
                                        <h4 className="font-bold text-gray-900">Ana P.</h4>
                                        <p className="text-xs text-orange-500 font-semibold uppercase tracking-wide mb-2">Designer</p>
                                        <p className="text-gray-600 text-sm">"A simplicidade é o que me ganhou. Nada de configurações complexas, só abrir e usar."</p>
                                    </div>
                                </div>
                            </div>

                            <div className="relative mt-8 lg:mt-0">
                                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-orange-200/20 rounded-full blur-3xl -z-10"></div>
                                <div className="relative bg-white p-8 md:p-12 rounded-3xl shadow-xl border border-gray-100 text-center">
                                    <div className="w-24 h-24 rounded-full bg-gray-100 mx-auto mb-6 overflow-hidden border-4 border-white shadow-lg">
                                        <img src={lucas} alt="Lucas" className="w-full h-full object-cover" />
                                    </div>
                                    <h3 className="text-2xl font-bold mb-2">Lucas S.</h3>
                                    <p className="text-orange-600 font-medium mb-6">Empreendedor</p>
                                    <blockquote className="text-lg text-gray-600 italic leading-relaxed">
                                        "O SkipLater mudou minha relação com a produtividade. Não é sobre fazer mais, é sobre fazer o que importa, todo dia."
                                    </blockquote>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="py-24 bg-background">
                    <div className="container px-4 mx-auto max-w-3xl">
                        <h2 className="text-3xl font-bold text-center mb-12">Dúvidas Frequentes</h2>
                        <div className="space-y-4">
                            {faqs.map((faq, i) => (
                                <div key={i} className="border border-border rounded-xl overflow-hidden bg-white/50">
                                    <button
                                        onClick={() => toggleFaq(i)}
                                        className="flex justify-between items-center w-full p-4 text-left font-semibold hover:bg-gray-50 transition-colors"
                                    >
                                        <span className="text-foreground">{faq.question}</span>
                                        <ChevronDown
                                            className={`w-5 h-5 text-muted-foreground transition-transform duration-200 ${openFaqIndex === i ? 'rotate-180' : ''
                                                }`}
                                        />
                                    </button>
                                    <div
                                        className={`grid transition-all duration-300 ease-in-out ${openFaqIndex === i ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                                            }`}
                                    >
                                        <div className="overflow-hidden">
                                            <p className="p-4 pt-0 text-muted-foreground leading-relaxed">
                                                {faq.answer}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="py-24 bg-gradient-to-br from-orange-50 via-white to-orange-50 text-center">
                    <div className="container px-4 mx-auto max-w-3xl">
                        <h2 className="text-4xl md:text-5xl font-bold mb-6">2026 não precisa ser mais um ano de recomeços.</h2>
                        <p className="text-xl text-muted-foreground mb-10">Pule o “depois”. Comece hoje — e construa hábitos melhores, um dia por vez.</p>
                        <div className="flex flex-col sm:flex-row gap-4 justify-center">
                            <button onClick={() => handleSubscribe(process.env.REACT_APP_STRIPE_PRICE_MONTHLY)} className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground shadow hover:bg-primary/90 h-14 px-8 text-lg rounded-full">
                                Assinar Mensal — R$ 9,90/mês
                            </button>
                            <button onClick={() => handleSubscribe(process.env.REACT_APP_STRIPE_PRICE_YEARLY)} className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 border border-input shadow-sm hover:bg-accent hover:text-accent-foreground h-14 px-8 text-lg rounded-full">
                                Assinar Anual — R$ 97/ano
                            </button>
                        </div>
                    </div>
                </section>

                <footer className="py-12 bg-background border-t border-border/50">
                    <div className="container px-4 mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
                        <div className="flex items-center gap-2">
                            <img src={logo2} alt="SkipLater" className="h-8 w-auto rounded-lg grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all" />
                            <span className="text-sm text-muted-foreground font-medium">SkipLater © 2025</span>
                        </div>

                        <div className="flex gap-6 text-sm text-muted-foreground">
                            <a href="/privacy" className="hover:text-foreground transition-colors">Politica de Privacidade</a>
                            <a href="/terms" className="hover:text-foreground transition-colors">Termos de Uso</a>
                        </div>
                    </div>
                </footer>
            </main>
        </div >
    );
};

export default LandingPage;
